import { Link } from 'react-router-dom';
import { COMPANY_CONFIG, NAV_ITEMS, CORPORATE_DISTINCTIONS } from '../config/site';

export function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="w-full bg-[#101828] text-white border-t border-[#172136] transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pt-16 pb-12 sm:pt-20 sm:pb-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 lg:gap-16 pb-16 border-b border-white/10">
          
          {/* Company Summary Column */}
          <div className="md:col-span-5 space-y-4">
            <Link to="/" className="inline-flex items-center gap-3 group">
              <img
                src="/safaza-icon.png"
                alt="Safaza mark"
                className="h-9 w-9 object-contain transition-transform duration-200 group-hover:scale-105"
              />
              <div className="flex flex-col">
                <span className="text-xl font-bold tracking-tight text-white leading-tight">Safaza</span>
                <span className="text-[10px] uppercase tracking-[0.2em] font-medium text-[#98A2B3]">Technologies</span>
              </div>
            </Link>

            <p className="text-sm text-[#98A2B3] leading-relaxed max-w-sm">
              {COMPANY_CONFIG.legalName} is a software development company engineering custom web and mobile applications, SaaS platforms, and enterprise integrations.
            </p>
          </div>

          {/* Navigation Links */}
          <div className="md:col-span-3 space-y-4">
            <h3 className="text-xs font-semibold uppercase tracking-wider text-white/50">
              Navigation
            </h3>
            <ul className="space-y-2.5 text-sm">
              {NAV_ITEMS.map((item) => (
                <li key={item.path}>
                  <Link
                    to={item.path}
                    className="text-[#98A2B3] hover:text-white transition-colors duration-150 inline-block py-0.5"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Legal & Governance */}
          <div className="md:col-span-4 space-y-4">
            <h3 className="text-xs font-semibold uppercase tracking-wider text-white/50">
              Corporate &amp; Legal
            </h3>
            <ul className="space-y-2.5 text-sm">
              <li>
                <Link
                  to="/privacy"
                  className="text-[#98A2B3] hover:text-white transition-colors duration-150 inline-block py-0.5"
                >
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link
                  to="/terms"
                  className="text-[#98A2B3] hover:text-white transition-colors duration-150 inline-block py-0.5"
                >
                  Terms of Use
                </Link>
              </li>
              <li className="pt-2">
                <span className="text-xs text-[#98A2B3] block">Direct Corporate Inquiries:</span>
                <a
                  href={`mailto:${COMPANY_CONFIG.contactEmail}`}
                  className="text-sm font-medium text-[#0D66E4] hover:underline"
                >
                  {COMPANY_CONFIG.contactEmail}
                </a>
              </li>
            </ul>
          </div>

        </div>

        {/* Corporate Scope & Entity Overview */}
        <div className="py-8 border-b border-white/10 text-xs text-[#98A2B3] leading-relaxed">
          <p className="font-semibold text-white/90 mb-1.5">
            Corporate Entity &amp; Scope Overview
          </p>
          <p className="mb-2">
            <strong>{COMPANY_CONFIG.legalName}</strong> is incorporated in the United States as a software development company. It provides custom software engineering services and SaaS platforms (including Akoole). It does not provide banking, money transmission, payment processing, deposit taking, cryptocurrency custody, or licensed financial services.
          </p>
          <p className="text-[#98A2B3]/80 text-[11px]">
            {CORPORATE_DISTINCTIONS.governanceNotice}
          </p>
        </div>

        {/* Bottom Copyright Line */}
        <div className="pt-8 flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-[#98A2B3]">
          <div>
            &copy; {currentYear} {COMPANY_CONFIG.legalName} All rights reserved.
          </div>
          <div>
            <span>{COMPANY_CONFIG.primaryDomain}</span>
          </div>
        </div>

      </div>
    </footer>
  );
}
